export default __webpack_public_path__ + "static/media/default_logo.3869d12f.svg";